import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatTime',
  standalone: false
})
export class FormatTimePipe implements PipeTransform {
  // value in milliseconds
  transform(value: number | null): string {
    if (!value) {
      return '00:00';
    }

    const minutes = Math.floor(value / 60000);
    const seconds = ((value % 60000) / 1000).toFixed(0);

    return `${this.pad(minutes)}:${this.pad(seconds)}`;
  }

  private pad(num: number | string): string {
    return num.toString().padStart(2, '0');
  }
}
